import React from "react";
import parse from "html-react-parser";
import { PopupboxManager, PopupboxContainer } from "react-popupbox";
import "react-popupbox/dist/react-popupbox.css";
import { useParams, useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Roles from "../components/Roles";
import Phases from "../components/Phase";
import { DownloadPdf } from "../components/Print";
import ProgressBar from "../components/ProgressBar";
import Notification from "../components/Notification";
import Suitcase from "../assets/icons/suitcase.svg";
import { useGlobalState } from "../context/Global";
import Alerts from "../components/Alert";

function Checklist() {
  const params = useParams();

  const { data, roles, phases, setActivePhase, tasks, activeTask, setActiveTask, tasksBundled } = useGlobalState();

  React.useEffect(() => {
    params.phase && setActivePhase(phases.find((p) => p.id == params.phase));
    params.task && setActiveTask(tasks.find((t) => t.$.id === params.task));
  }, [tasks, phases, params]);

  return (
    <>
      <Header />
      <Alerts />

      <div className="xl:container px-8">
        <div className="flex -mx-6 mb-4">
          <aside className="w-1/3 px-6 ">
            <ProgressBar title="completed" />
            <div className="flex mt-5 relative flex-wrap">
              <div className={roles.length > 0 ? "w-full xl:w-1/2 mb-2" : "w-full mb-2"}>
                <div className={roles.length > 0 ? "xl:pr-1" : ""}>{phases.length && tasks.length && <DownloadPdf tasks={tasks} phases={phases} tasksBundled={tasksBundled} roles={roles} />}</div>
              </div>
              {roles.length > 0 && (
                <div className="w-full xl:w-1/2">
                  <Roles />
                </div>
              )}
            </div>
            <div className=" sticky top-0 overflow-y-auto " style={{ height: "80vh" }}>
              <Phases />
            </div>
          </aside>

          <main className="w-2/3 px-6 content" style={{ minHeight: "100vh" }}>
            {activeTask && (
              <div className="-mx-1">
                {roles
                  .filter((r) => (activeTask.$ ? activeTask.$.role?.split(" ")?.includes(r.$.id) : false))
                  .map((r, i) => (
                    <div key={"task" + i} className="bg-primary-light text-primary-dark py-1 px-3 inline-flex mb-4 mx-1 text-sm">
                      <Suitcase className="fill-current mr-2" width="12" height="18" />
                      {r._}
                    </div>
                  ))}
              </div>
            )}
            <h1 className="text-3xl font-black text-black mb-8">{activeTask?.title}</h1>
            <Notification id={activeTask?.$?.id} type="warning" notification={activeTask?.warning} />
            <div className="body">
              {activeTask?.body?._ &&
                parse(activeTask.body._, {
                  replace: (domNode) => {
                    const { attribs, children } = domNode;

                    //replace XML img tags by SRLWrapper
                    if (attribs && (attribs.href?.includes("jpg") || attribs.href?.includes("png") || attribs.href?.includes("gif"))) {
                      if (children && children[0].attribs.src) {
                        const child = children.find((c) => c.attribs?.src);
                        return (
                          <a
                            onClick={() =>
                              PopupboxManager.open({
                                content: <img src={attribs.href} />,
                                config: {
                                  titleBar: {
                                    enable: true,
                                  },
                                  fadeIn: true,
                                  fadeInSpeed: 500,
                                },
                              })
                            }
                            className="block mb-6"
                          >
                            <img src={child.attribs.src} />
                          </a>
                        );
                      }
                    }

                    //if nothing to replace, just return XML dom
                    return domNode;
                  },
                })}

              <PopupboxContainer />
            </div>
            {data.taskfooter && <div className="bg-gray-200 p-8 text-center mt-64" dangerouslySetInnerHTML={{ __html: data.taskfooter }} />}
          </main>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Checklist;
